import React, { useEffect, useState } from "react";
import { grouplist, groupmemberlist, outstandinglist } from "../../../services/admin";
import exportUrl from "../../../exportUrl";
import { deliverReport } from "../../../utils/printPdf";
import { toast } from "react-toastify";
import moment from "moment";
import Select from "react-select";

export const OutstandingSheet = () => {
    const [glist, setGlist] = useState([]);
    const [grpid, setGrpId] = useState("");
    const [mgrpid, setMGrpId] = useState("");
    const [mlist, setMlist] = useState([]);
    const [memid, setMemId] = useState("");
    const [filterProduct, setFilterProduct] = useState([]);

    useEffect(() => {
        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].group_name
                        })
                    }
                    setGlist(arr);
                }
            }
        })
    }, []);

    function handlegroup(e) {
        if (e !== null) {
            setMGrpId(e);
            setGrpId(e.value);
            setMemId("");
            setMlist([]);
            setFilterProduct([]);
            if (e.value != "") {
                groupmemberlist(e.value).then((res) => {
                    if (res.status === true) {
                        setMlist(res.data);
                    }
                });
            }
        } else {
            setMGrpId("");
            setGrpId("");
            setMemId("");
            setMlist([]);
            setFilterProduct([]);
        }

    }

    function handlemember(e) {
        setMemId(e.target.value);
        setFilterProduct([]);
        if (e.target.value != "") {
            const temp = new FormData();
            temp.append("group_id", grpid);
            temp.append("member_id", e.target.value);
            outstandinglist(temp).then((res) => {
                if (res.status === true) {
                    setFilterProduct(res.data);
                }
            });
        }
    }
    const isDrnWealth = (() => {
        if (typeof exportUrl === "string" && exportUrl.toLowerCase().includes("drnwealth")) {
            return true;
        }
        if (typeof window !== "undefined" && window.location) {
            if (window.location.hostname.toLowerCase().includes("drnwealth") || window.location.href.toLowerCase().includes("drnwealth")) {
                return true;
            }
        }
        return false;
    })();

    function downloadfile(fid, mid, dtype) {
        if (fid !== "" && mid !== "") {
            let url = exportUrl + 'report/outstandingdownload?group_id=' + fid + '&member_id=' + mid + '&type=' + dtype;
            url += isDrnWealth ? '&is_drn=1' : '&is_drn=0';
            deliverReport(url, dtype);
        } else {
            toast.error("Please Select Group");
        }
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Outstanding Report</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Outstanding Report
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Outstanding Report
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Group<span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Select Group"
                                                value={mgrpid}
                                                options={glist}
                                                onChange={handlegroup}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Member<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="default-select form-control wide"
                                                onChange={handlemember}
                                                value={memid}
                                            >
                                                <option value="" disabled>
                                                    Select Member
                                                </option>
                                                {mlist.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>
                                                            {item.member_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6 mt-4">
                                        <div className="text-end">
                                            <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, memid, 'pdf')}>Download PDF</a>
                                            <a className="btn btn-success me-2" onClick={() => downloadfile(grpid, memid, 'excel')}>Download Excel</a>
                                            <a className="btn btn-primary" onClick={() => downloadfile(grpid, memid, 'print')}>Print</a>
                                        </div>
                                    </div>

                                </div>
                                {filterProduct.map((item, index) => {
                                    if (isDrnWealth) {
                                        const schemeEntries = item.scheme_entries || [];
                                        let runningOpening = parseFloat(item.total_amount || 0);
                                        let totInst = 0;
                                        let totInt = 0;
                                        let totPrin = 0;

                                        return (
                                            <div className="row mt-4" key={index}>
                                                {/* <div className="col-12 text-center mb-3">
                                                    <img
                                                        src={require("../../../assets/images/logo/service_logo.png")}
                                                        alt="Logo"
                                                        style={{ maxHeight: "65px", marginBottom: "5px" }}
                                                        onError={(e) => {
                                                            e.target.src = require("../../../assets/images/logo/amylogo.png");
                                                            e.target.onerror = null;
                                                        }}
                                                    />
                                                    <h4 className="fw-bold text-uppercase mb-1">AMY FINTECH SOFTWARE</h4>
                                                </div>*/}
                                                <div className="col-12 text-start mb-3">
                                                    <h6 className="fw-bold mb-1">Instructions:</h6>
                                                    <p className="mb-2">Ensure to collect the printed reciept for the payment made</p>
                                                    <h5 className="fw-bold text-uppercase mt-3">REPAYMENT SCHEDULE</h5>
                                                </div> 
                                                <div className="table-container">
                                                    <table className="responsive-table table-bordered">
                                                        <thead>
                                                            <tr style={{ backgroundColor: "#d3d3d3" }}>
                                                                <th style={{ backgroundColor: "#d3d3d3", color: "#000", fontWeight: "bold" }}>Inst No.</th>
                                                                <th style={{ backgroundColor: "#d3d3d3", color: "#000", fontWeight: "bold" }}>Inst Date</th>
                                                                <th style={{ backgroundColor: "#d3d3d3", color: "#000", fontWeight: "bold" }}>Opening Balance</th>
                                                                <th style={{ backgroundColor: "#d3d3d3", color: "#000", fontWeight: "bold" }}>Installment Amt</th>
                                                                <th style={{ backgroundColor: "#d3d3d3", color: "#000", fontWeight: "bold" }}>Int Amt</th>
                                                                <th style={{ backgroundColor: "#d3d3d3", color: "#000", fontWeight: "bold" }}>Principal Amt</th>
                                                                <th style={{ backgroundColor: "#d3d3d3", color: "#000", fontWeight: "bold" }}>Closing Balance</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {schemeEntries.map((data, i) => {
                                                                const instAmt = parseFloat(data.total || 0);
                                                                const intAmt = parseFloat(data.interest_amount !== undefined && data.interest_amount !== null && data.interest_amount !== "" ? data.interest_amount : (data.interest || 0));
                                                                const prinAmt = parseFloat(data.principal_amount !== undefined && data.principal_amount !== null && data.principal_amount !== "" ? data.principal_amount : (instAmt - intAmt));

                                                                let openingBal = runningOpening;
                                                                if (i === 0) {
                                                                    // The server's opening balance is the sum of the
                                                                    // schedule's own principal, so the closing column
                                                                    // reaches zero; the sanctioned scheme amount can
                                                                    // differ from it once the dues are rounded.
                                                                    if (parseFloat(data.opening_balance || 0) > 0) {
                                                                        openingBal = parseFloat(data.opening_balance);
                                                                    } else if (parseFloat(item.total_amount || 0) > 0) {
                                                                        openingBal = parseFloat(item.total_amount);
                                                                    } else if (parseFloat(data.remaining_total_amount || 0) > 0) {
                                                                        openingBal = parseFloat(data.remaining_total_amount);
                                                                    } else {
                                                                        openingBal = parseFloat(data.outstanding || 0) + prinAmt;
                                                                    }
                                                                }
                                                                const closingBal = openingBal - prinAmt;
                                                                runningOpening = closingBal;

                                                                totInst += instAmt;
                                                                totInt += intAmt;
                                                                totPrin += prinAmt;

                                                                let instDate = data.inst_date;
                                                                if (!instDate && item.loan_date) {
                                                                    instDate = moment(item.loan_date).add(i + 1, 'months').format('DD-MMM-YY');
                                                                }

                                                                return (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{instDate || '-'}</td>
                                                                        <td>{openingBal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                        <td>{instAmt.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                        <td>{intAmt.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                        <td>{prinAmt.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                        <td>{closingBal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                            <tr style={{ fontWeight: 'bold' }}>
                                                                <td colSpan="3" className="text-start">TOTAL</td>
                                                                <td>{totInst.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                <td>{totInt.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                <td>{totPrin.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="col-12 text-start fw-bold mt-4 mb-2">
                                                    CUSTOMER'S SIGNATURE
                                                </div>
                                                <hr />
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="row mt-4" key={index}>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Collection Day : {item.group_collection_day}
                                                </p>
                                            </div>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Interest Per Due : {parseFloat(item.interest).toFixed(2)}
                                                </p>
                                            </div>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Loan Date : {item.loan_date !== null ? moment(item.loan_date).format('DD-MM-YYYY') : ''}
                                                </p>
                                            </div>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Staff : {item.staff_name}
                                                </p>
                                            </div>
                                            <div className="table-container">
                                                <table className="responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Due Date</th>
                                                            <th>Total EMI</th>
                                                            <th>Principle</th>
                                                            <th>Interest</th>
                                                            <th>Outstanding</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {item.scheme_entries.map((data, i) => {
                                                            return (
                                                                <tr key={i}>
                                                                    <td>{i + 1}</td>
                                                                    <td>{data.inst_date}</td>
                                                                    <td>{data.total}</td>
                                                                    <td>{data.principal_amount}</td>
                                                                    <td>{data.interest_amount}</td>
                                                                    <td>{data.outstanding}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr />
                                        </div>
                                    )
                                })

                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
